var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiesel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.4996L7.50004 9.99956M10 12.4996C11.1641 12.0568 12.2808 11.4985 13.3334 10.8329M10 12.4996V16.6662C10 16.6662 12.525 16.2079 13.3334 14.9996C14.2334 13.6496 13.3334 10.8329 13.3334 10.8329M7.50004 9.99956C7.94349 8.84908 8.50188 7.74627 9.16671 6.70789C10.1377 5.15538 11.4897 3.8771 13.0942 2.99463C14.6987 2.11217 16.5023 1.65486 18.3334 1.66622C18.3334 3.93289 17.6834 7.91622 13.3334 10.8329M7.50004 9.99956H3.33337C3.33337 9.99956 3.79171 7.47456 5.00004 6.66622C6.35004 5.76622 9.16671 6.66622 9.16671 6.66622M3.75004 13.7496C2.50004 14.7996 2.08337 17.9162 2.08337 17.9162C2.08337 17.9162 5.20004 17.4996 6.25004 16.2496C6.84171 15.5496 6.83337 14.4746 6.17504 13.8246C5.85113 13.5154 5.42445 13.3368 4.9769 13.3229C4.52934 13.3091 4.09244 13.461 3.75004 13.7496Z",
    stroke: "#165AE3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiesel);
export default __webpack_public_path__ + "static/media/diesel.913ae2752189f9f2267dbebe8018643d.svg";
export { ForwardRef as ReactComponent };